import React from "react";

const LiteracyLearningPlay: React.FC = () => {
  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto text-center">
          <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            문해력 학습 하기
          </h2>
          <div className="font-bold text-gray-600 sm:text-xl dark:text-gray-400 mb-8">
            시작해 보세요!
          </div>

          {/* 모바일과 데스크톱에서의 iframe 크기 조정 */}
          <div className="relative overflow-hidden w-full h-[100vh]">
            <iframe
              src="https://chamstudyland.com/literacy/"
              className="absolute top-0 left-0 w-full h-full border-0"
              allowFullScreen
              title="문해력 학습"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiteracyLearningPlay;
